var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00012 1C9.00012 0.447715 8.55241 0 8.00012 0C7.44784 0 7.00012 0.447715 7.00012 1V9.08579L5.20723 7.29289C4.8167 6.90237 4.18354 6.90237 3.79302 7.29289C3.40249 7.68342 3.40249 8.31658 3.79302 8.70711L8.00012 12.9142L12.2072 8.70711C12.5978 8.31658 12.5978 7.68342 12.2072 7.29289C11.8167 6.90237 11.1835 6.90237 10.793 7.29289L9.00012 9.08579V1Z",
    fill: "#FF552E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2H4.00012C4.55241 2 5.00012 2.44772 5.00012 3C5.00012 3.55228 4.55241 4 4.00012 4H2V14H14V4H12.0001C11.4478 4 11.0001 3.55228 11.0001 3C11.0001 2.44772 11.4478 2 12.0001 2H16V16H0V2Z",
    fill: "#FF552E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.e76d7a688f70ceb123d132c6bc27269b.svg";
export { ForwardRef as ReactComponent };